import PersonIcon from "@mui/icons-material/Person";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const mainField = "id";

const dataFieldConfig = [
    {
        id: "created_at",
        field: "created_at",
        align: "center",
        disablePadding: false,
        label: "參與者時間",
        fieldAction: () => { },
    },
    {
        id: "display_name",
        field: "display_name",
        align: "center",
        disablePadding: false,
        label: "參與者名字",
        fieldAction: () => { },
    },
    {
        id: "member_id",
        field: "member_id",
        align: "center",
        disablePadding: false,
        label: "ECLASS編號",
        fieldAction: () => { },
    },
    {
        id: "phone_num",
        field: "phone_num",
        align: "center",
        disablePadding: false,
        label: "電話",
        fieldAction: () => { },
    },
    {
        id: "qrcode_id",
        field: "qrcode_id",
        align: "center",
        disablePadding: false,
        label: "QRCode號碼",
        fieldAction: () => {  },
    },
    {
        id: "group",
        field: "group",
        align: "center",
        disablePadding: false,
        label: "組別/班別",
        fieldAction: () => { },
    },
    {
        id: "group_num",
        field: "group_num",
        align: "center",
        disablePadding: false,
        label: "編號/班號",
        fieldAction: () => { },
    },
    {
        id: "skill_code",
        field: "skill_code",
        align: "center",
        disablePadding: false,
        label: "技能編號",
        fieldAction: () => { },
    },
    {
        id: "skill_name_zh",
        field: "skill_name_zh",
        align: "center",
        disablePadding: false,
        label: "技能名字",
        fieldAction: () => { },
    },
    {
        id: "skill_score",
        field: "skill_score",
        align: "center",
        disablePadding: false,
        label: "成績",
    },
    {
        id: "skill_unit",
        field: "skill_unit",
        align: "center",
        disablePadding: false,
        label: "單位",
    },
];

const fetchDataConfig = {
    // url: "/organization/query",
    url: "/memberSkillData/query",
    // fixedFilter: [{ field: "name_en,name_zh", value: '', op: "like" }],
    // extraQuery: [{ key: "org", field: "orgId" }],
    // fixedFilter: [],
};


const tableActionConfig = [
    {
        key: "deleteRecord",
        type: "confirmDialog",
        label: "Delete",
        icon: "delete",
        url: "/admin/skillRecord/delete/$id", 
        dialogConfig: {
            /** https://sweetalert2.github.io/#usage */
            title: "確定要刪除嗎？",
            icon: "warning",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonAriaLabel: "確定",
            cancelButtonAriaLabel: "取消",
            cancelButtonColor: "#a7a7a7",
            successMsg: "刪除成功",
            failMsg: "刪除失敗",
        },
        // icon: EmojiEventsIcon,
    },
    // {
    //     type: "link",
    //     label: "View Contents",
    //     icon: "detail",
    //     // icon: EmojiEventsIcon,
    //     url: "/equipment/detail/$id",   /// Delete 
    // },
];

const filterConfig = [
];

const TableConfig = {
    mainField,
    dataFieldConfig,
    fetchDataConfig,
    tableActionConfig,
    filterConfig,
};

export default TableConfig;
